import Page404 from './Page404.vue'

export default Page404
